module.exports = __webpack_public_path__ + "static/media/10_CORTINAO_SEM_BOJO_LISO_03.0476fcec.jpg";